import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";

import { Carousel, Slide } from 'vue-carousel';
import tooltip from "./tooltip.js"

const template = `
	<div>
	
		<div class="quote-select card " :class="quoteType" :uid="input.uid" v-if="(!input.qc_type || input.qc_type == 1) && showComponent" >
			<div>
				<img class="center carrier-logo" :src="icon(input.data)" :alt="input.data.carrier_name"/>
				<p v-if="checkIfBundle(input.uid)" class="lob">{{ input.data.lob_text }}</p>

				<p class="quote">$\{{ input.data.monthly }}<small>/month</small></p>
				<p class="total-premium">$ {{ input.data.onePayPossiblePIF }} Total Premium </p>

				<p class="discount" v-if="input.data.groupDiscount">
					<img alt="" class="iconic iconic-sm" data-src="/static/images/iconic/star.svg"> {{ input.data.groupDiscount }} <img alt="Group Discount" class="iconic iconic-sm" data-src="/static/images/iconic/star.svg">
				</p>

				<button tabindex="0" role="button" class="lob-label" @click.prevent="toggleAccordion()"  @keydown.prevent.enter="toggleAccordion()" @keydown.prevent.space="toggleAccordion()"  v-html="showCoverageText"></button>
				<button v-if="accordionIsOpen && checkIfBundle(input.uid)" v-for="feature in input.features" class="lob-label " :class="quoteType.length > 1 ? ' table-title ': ''"   v-html="">{{feature.label}}</button>

				<div class="grid collapse" :class="quoteType.length > 1 ? ' dual-table ': ''" >
					<div class="accordion clm" v-for="(feature, fi) in input.features" :class="feature.class">
						<ul class=" table coverage-table accordion-item" :class="{open: accordionIsOpen}" >
							<li class="tr"  v-for="(item,i) in feature.items" v-if="accordionIsOpen" >
								<div class="td td6 text-right" ><span :ref="input.uid+'-label-'+fi+'-'+i">{{ item.label }}</span></div>
								<div  class="td td6 text-left" >
									<span :ref="input.uid+'-value-'+fi+'-'+i" >
										{{ item.value }}
										<b-tooltip :element='item' v-show="item.helpText" v-if="accordionIsOpen" />
									</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="grid collapse">
					<div class="s12 m10 clm center">
						<button v-if="input.quote_type != 2" :aria-label="input.button_text+' - '+input.data.carrier_name" class="button medium action fill primary-btn next-step" @click.prevent="exec($event, input, {skipUpdate:true})">
							{{input.button_text}}
							<img alt="" class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
						</button>
					</div>
				</div>
			</div>
			<div class="error-here"></div>
		</div>

		
		<div class="quote-select card type-2" :uid="input.uid" v-show="fs.display(input) && !fs.isMobile() " v-if="input.qc_type == 2" >
			<div>
				<p class="quote" v-html="computedAdtLabel"></p>
				<h4 class="total-premium" v-html="computedAdtValue"></h4>
				<div class="grid collapse btn-container">
					<div class="s12 m10 clm center">
						<button v-if="input.quote_type != 2" class="button medium action fill primary-btn next-step" @click.prevent="exec($event, input, {skipUpdate:true})">
							{{input.button_text}}
							<img alt="Arrow" class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
						</button>
					</div>
				</div>
			</div>
			<div class="error-here"></div>
		</div>
	</div>
	
`

export default {
	name: 'b-quote-card',
	template,
	props: ['iuid'],
	data() {
        return {
            "accordionIsOpen":false
        }
    },
	mixins: [Mixin],
	components: {
		Carousel,
		Slide,
		'b-tooltip': tooltip
	},
	computed: {
		...Vuex.mapGetters([
            'funnel',
			'active_page'
        ]),
		showComponent: function(){
			console.log("active page: "+this.active_page);
			if ((this.fs.display(this.input) && !this.fs.isMobile()) || this.active_page == 'pg_rtq_success') {
				return true
			}
			return false
		},
		showCoverageText: function(){
			return this.accordionIsOpen ? 'Hide Coverages' : 'Show Coverages';
		},
		fs: function () {
			return new Funnel({ ctx: this.$store, router: this.$router });
		},
		input: function () {
			return this.$store.getters.funnel.elements[this.iuid];
		},
		items: function () {
			return { ... this.input.options };
		},
		computedAdtLabel: function(){
			//we need the rreal number calculated from the total of non shown quotes
			return this.input.label
		},
		computedAdtValue:function(){
			return this.input.value
		},
		quoteType: function(){
			if (this.input.qexec) {
				var self = this;
				var qt = []
				Object.keys(self.input.qexec).map(function(key){
					qt.push(key) 
				})
				return qt
			}
			
		}
		
	},
	mounted: function(){
		this.checkIfBundle(this.input.uid)
	},
	methods: {
		checkLineBreak:function(el, text){
			if (this.$refs[el]) {
				var element = this.$refs[el];
				var text = element[0];
				console.log(element);
				// var match = /\r|\n/.exec(text);
				// if (match) {
				// 	console.log(text);
				// } 
				// return false
			}
			
		},
		toggleAccordion: function(){
			this.accordionIsOpen = !this.accordionIsOpen
		},
		checkIfBundle: function(iuid){
			if (!this.quoteType) {
				return
			}
			if (this.quoteType.length > 1 ) {
                console.log("it's a bundle "+ iuid);
				console.log(this.input);
                if (this.input.class.indexOf('l6') == -1) {
                    // this is a workaround for identifying bundle quotes and showing them bigger on the screen  -G
                    //because the renderer is the one who assigns the classes on page.js it's impossible for me to change the class for bundles without modifying the element itself -g
					console.log('doesnt have m10 l6');
                    var cssClass = `${this.funnel.elements[iuid].class} m10 l6`;
					this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'class', val: cssClass });
                }
				return true
            }
		},
		icon: function (item) {
			let iconName;
			if (item.icon_name) {
				iconName = item.icon_name
			} else {
				let text = this.input.label
				iconName = text.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "");
			}
			const pathToIcon = '/static/images/carriers/'
			const iconFormat = '.svg'
			return pathToIcon + iconName + "-color" + iconFormat;
		},
		tableTitle: function(qt){
			if (qt == 'auto') {
				return 'Auto Coverages'
			}
			if (qt == 'home') {
				return 'Home Coverages'
			}
			if (qt == 'rent') {
				return 'Coverages'
			}
			
		}
		
	}
};